import { observer } from 'mobx-react-lite'
import { SelectContainer } from '@/components/inputs/SelectContainer'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { useFeatures } from '@/contexts/root-store-context'
import { InviteTeamMemberModal } from '@/features/iam/teams/InviteTeamMemberModal'
import { type InviteTeamMemberModalViewModel } from './InviteTeamMemberModalViewModel'

export interface InviteTeamMemberModalContainerProps {
  vm: InviteTeamMemberModalViewModel
}

export const InviteTeamMemberModalContainer = observer(
  function InviteTeamMemberModalContainer({
    vm,
  }: InviteTeamMemberModalContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <InviteTeamMemberModal
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        corporateMode={shellInfo.corporateMode}
        onSend={vm.sendInvite}
        isSendPending={vm.sendInvite.pending}
        inviteCount={vm.emailAddresses.length}
      >
        <TextAreaContainer
          label="Email address(es)"
          help="You can comma- or newline-separate emails to invite multiple people."
          className="textarea"
          error={vm.validation.getError('email')}
          rows={5}
          model={vm}
          field="email"
        />
        <br />
        <SelectContainer
          label="Role"
          items={vm.teamRoleOptions.map((role) => [role.id, role.name])}
          model={vm}
          field="teamRoleId"
          help="When someone accepts the invitation, they are given this role."
        >
          {vm.teamRoleOptions.map((role) => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </SelectContainer>
      </InviteTeamMemberModal>
    )
  },
)
